import { signal } from "@preact/signals-react";

import dates from "componentsv2/tools/dates";
import { useIntl } from "react-intl";

const formatter = Intl.NumberFormat("en-US");
// const excludeFields = [
//   "button",
//   "button_wizard",
//   "icon",
//   "divider",
//   "multiselection",
//   "title",
//   "p",
//   "custom",
//   "button_custom_modal",
// "one2many", ???
//   "custom_fragment",
// ];

const includeFields = [
  "char",
  "boolean",
  "integer",
  "many2one",
  "selection",
  "numeric",
  "date",
  "datetime",
  "text",
  "time",
  "date_2",
  "float",
];

const prepareRecord = (record) => {
  if (!record) {
    return {};
  }
  for (let [key, value] of Object.entries(record)) {
    if (Array.isArray(value)) {
      value = recsToMap(value);
    }
    if (key.includes(".")) {
      const nkey = key.replace(".", "");
      const subValue = prepareRecord(value);
      record[nkey] = subValue;
      delete record[key];
    }
  }
  return record;
};

const recsToMap = (records) => {
  const _map = new Map();
  for (let rec of records) {
    rec = prepareRecord(rec);
    _map.set(rec.id, rec);
  }
  return _map;
};

function getLabel(field, typeView, model) {
  let label = field.name;
  if (typeView !== "tree") {
    label = `${model}.${label}`;
  }
  return label;
}

function getRequired(field, record) {
  if (typeof field.getRequired === "function") {
    return field.getRequired(record);
  }
  const type_ = field.widget || field.type;
  if (["button_tab", "button_check", "button"].includes(type_)) {
    return false;
  }
  let required = field.required || false;
  if (typeof field.required === "function") {
    required = field.required(record);
  }
  return required;
}

function getReadOnly(field, record, parentRec) {
  let readOnly = false;
  if (parentRec?.readOnly) {
    readOnly = true;
  } else if (typeof field.readOnly === "boolean") {
    readOnly = field.readOnly;
  } else if (record && typeof field.readOnly === "function") {
    readOnly = field.readOnly(record, parentRec);
  }
  // else if (record && field.readOnly) {
  //   for (const [keyField, valuesField] of Object.entries(field.readOnly)) {
  //     if (valuesField.includes(record[keyField])) {
  //       readOnly = true;
  //     }
  //   }
  // }
  return readOnly;
}

function getValue(field, record) {
  let value = "";
  if (record && ![undefined, null].includes(record[field.name])) {
    value = record[field.name];
  } else if (typeof field.function === "function") {
    value = field.function(record, field);
  } else if (field.default) {
    if (record?.id <= 0 || !record?.id) {
      if (typeof field.default === "function") {
        // Insert here activeRecord or childRecord
        value = field.default();
      } else {
        value = field.default;
      }
    }
  }
  if (field.type === "numeric" && value && value !== "") {
    value =
      typeof value === "string" ? value : formatter.format(value.toString());
  } else if (field.type === "one2many") {
    // prueba
  }
  return value;
}

function getInvisible(field, record) {
  let isInvisible = false;
  if (record && field.invisible) {
    isInvisible = field.invisible(field.name, record);
  }
  return isInvisible;
}

function getAling(field, record) {
  let aling = "text-center";
  if (["char", "many2one"].includes(field.type)) {
    aling = "text-left";
  } else if (["numeric", "float"].includes(field.type)) {
    aling = "text-right";
  }
  return aling;
}

const recordToJs = (record, fields) => {
  // This function convert record Tryton in record Js for form/modal views
  const _record = { ...record };
  for (const [field, attr] of Object.entries(fields)) {
    let _value = record[field];
    if (attr.type === "selection") {
      let nameStr = _value;
      for (const opt of attr.options) {
        if (opt.id === _value) {
          nameStr = opt.name;
          break;
        }
      }
      if (_value) {
        _value = { id: _value, name: nameStr };
      }
    } else if (attr.type === "one2many") {
      const _field = `${field}.`;
      _value = record[_field];
      if (_value) {
        _value = recsToMap(_value);
      }
    } else if (attr.type === "many2one") {
      const _field = `${field}.`;
      _value = record[_field];
      const subValue = prepareRecord(_value);
      _record[field] = subValue;
    } else if (attr.type === "date" || attr.type === "date_2") {
      _value = dates.getTrytonDate2Js(_value, true);
    } else if (attr.type === "datetime") {
      if (_value) {
        _value = new Date(`${_value}Z`);
      } else {
        _value = "";
      }
    } else if (attr.type === "time") {
      if (_value) {
        if (typeof _value === "string" && _value.includes("T")) {
          _value = dates.getTrytonDateTimeLocal2Js(_value);
        } else {
          _value = dates.getTrytonTime2Js(_value);
        }
      } else {
        _value = "";
      }
    }
    _record[field] = _value;
  }
  return _record;
};

function getViewFields(layout, typeView) {
  const fieldsToApi = [];
  let viewTarget = [];
  let _typeView = typeView || layout.defaultView;
  if (!_typeView) {
    _typeView = "list";
  }
  if (typeView === "list") {
    viewTarget = layout.list.map((fd) => fd.name);
  } else if (_typeView === "form") {
    // For Form we need usually all fields
    viewTarget = Object.keys(layout.fields);
  } else if (_typeView === "cards") {
    viewTarget = layout.cards.map((fd) => fd.name);
  }

  function flatView(target) {
    const addTarget = [];
    for (const fieldObj of target) {
      if (fieldObj.type === "grid") {
        addTarget.push(fieldObj.elements);
      } else if (fieldObj.type === "tabs") {
        const tabsFields = [];
        for (const values of Object.values(fieldObj.elements)) {
          for (const _field of values) {
            tabsFields.push(_field);
          }
        }
        addTarget.push(tabsFields);
      }
    }
    return addTarget;
  }
  viewTarget = [...viewTarget, ...flatView(viewTarget)];

  for (const field of viewTarget) {
    // const field = fieldObj.name;
    const dataField = layout.fields[field];
    if (!dataField) continue;

    if (dataField?.depends) {
      fieldsToApi.push(...dataField.depends);
    }

    if (dataField?.function && dataField.attrs) {
      for (const f of dataField.attrs) {
        fieldsToApi.push(f);
      }
      continue;
    }

    if (dataField.function && dataField.search !== true) {
      continue;
    }

    if (includeFields.includes(dataField.type) || dataField.search) {
      if (dataField.search !== false) {
        fieldsToApi.push(field);
      }
    }

    if (dataField.type === "many2one") {
      let recName = "rec_name";
      if (dataField.recName) {
        recName = dataField.recName;
      }
      fieldsToApi.push(`${field}.${recName}`);
      if (dataField.fieldsNames) {
        for (const fname of dataField.fieldsNames) {
          fieldsToApi.push(`${field}.${fname}`);
        }
      }
      if (dataField.attrs) {
        for (const f of dataField.attrs) {
          fieldsToApi.push(field + "." + f);
        }
      }
    } else if (dataField.type === "one2many") {
      const subfieldsList = getViewFields(dataField.layout, "list");
      const subfieldsForm = [];
      const subfields = [...subfieldsList, ...subfieldsForm];
      for (const sub of subfields) {
        const nameNested = `${field}.${sub}`;
        fieldsToApi.push(nameNested);
      }
    }
  }
  return fieldsToApi;
}

function recToTryton(record) {
  // This function convert record store in Js to record for Tryton DB
  // Example:
  const rec = record instanceof Map ? record : Object.entries(record);
  const _record = {};
  for (const [key, value] of rec) {
    if (key === "rec_name") {
      continue;
    }

    if (value instanceof Map) {
      const list = [];
      const _createMap = value.get("create"); // Return Map create
      const _writeMap = value.get("write"); // Return a Map write
      const _deleteArray = value.get("delete"); // Return a Array to delete
      if (_createMap || _writeMap || _deleteArray) {
        if (_createMap && _createMap.size > 0) {
          const to_create = _createMap.values();
          const list_recs = Array.from(to_create);
          for (const lrec of list_recs) {
            for (const [_field, _val] of Object.entries(lrec)) {
              if (_val instanceof Object && _val.id > 0) {
                lrec[_field] = _val.id;
              }
            }
          }
          list.push(["create", list_recs]);
        }
        if (_writeMap && _writeMap.size > 0) {
          for (const rec of _writeMap.values()) {
            const childRec = recToTryton(rec);
            delete childRec.id;
            list.push(["write", [rec.id], childRec]);
          }
        }
        if (_deleteArray && _deleteArray.length > 0) {
          list.push(["delete", _deleteArray]);
        }
        if (list.length > 0) {
          _record[key] = list;
        }
      }
    } else if (value instanceof Object && value.id > 0) {
      _record[key] = value.id;
    } else if (value instanceof Object && value.id) {
      // Used for selection field
      _record[key] = value.id;
    } else {
      _record[key] = value;
    }
  }
  return _record;
}

async function getDefaults(id, layout) {
  const _fields = layout.fields;
  const toActive = { id: id };
  const toStore = { id: id };
  for (const [fieldName, val] of Object.entries(_fields)) {
    // console.log("k es ", k);
    if (typeof val.default === "function") {
      let value = await val.default();
      if (val.type === "date" || val.type === "date_old") {
        value = `${value}Z`;
      }
      toActive[fieldName] = value;
      toStore[fieldName] = value;
    } else if (val.default) {
      toActive[fieldName] = val.default;
      toStore[fieldName] = val.default;
    }
    if (val.type === "one2many") {
      toActive[fieldName] = signal(new Map());
      toStore[fieldName] = new Map();
      const toStoreField = toStore[fieldName];
      toStoreField.set("create", new Map());
      toStoreField.set("write", new Map());
      toStoreField.set("delete", []);
    }
  }
  return [toStore, toActive];
}

function genStoreId(model, key, parentRecId) {
  let dataKey = key;
  if (parentRecId) {
    // parentRec is important when we need to generate a storeId in cases as
    // sale.line which points to sale model record
    dataKey = [parentRecId].toString();
  }
  const res = `${model}|${dataKey}`;
  return genHashCode(res);
}

function genHashCode(str) {
  return str
    .split("")
    .reduce(
      (prevHash, currVal) =>
        ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
      0,
    );
}

function getAllRequired(fields, record) {
  const required = [];
  for (const [k, v] of Object.entries(fields)) {
    if (typeof v.getRequired === "function") {
      const req = v.getRequired(record);
      if (req) {
        required.push(k);
      }
    } else if (typeof v.required === "function") {
      const req = v.required(record);
      if (req) {
        required.push(k);
      }
    } else if (v.required) {
      required.push(k);
    }
  }
  return required;
}

function validateForm(record, storeData, fields) {
  const requiredFields = getAllRequired(fields, record?.active ?? record);
  console.log("requiredFields ...", requiredFields, storeData);
  const action = record.store.id > 0 ? "update" : "create";
  let msg = "ok";
  const msgMissingRequired = "board.missing_required_fields";
  const storeKeys = [];
  Object.entries(storeData).forEach(([k, v]) => {
    if (v && v !== "") {
      storeKeys.push(k);
    }
  });
  if (action === "create") {
    const result = requiredFields.every((field) => storeKeys.includes(field));
    // console.log("storeKeys", storeKeys);
    // console.log("requiredFields", requiredFields);
    // console.log("result", result);
    if (!result) {
      for (const rfield of requiredFields) {
        if (!storeKeys.includes(rfield)) {
          msg = msgMissingRequired;
          // console.log("Missing this required field: ", rfield);
          break;
        }
      }
      msg = msgMissingRequired;
    }
  } else {
    for (const fieldReq of requiredFields) {
      const value = record.active[fieldReq];
      // console.log("fieldReq...", fieldReq, value);
      if (!value || value === "") {
        msg = msgMissingRequired;
        // console.log("Missing this required field: ", fieldReq);
        break;
      }
    }
  }

  return { msg };
}

function strTranslate(translate, model, nameRec) {
  const intl = useIntl();
  const msg =
    translate && model && nameRec !== ""
      ? intl.formatMessage({
          id: `${model}.${nameRec}`,
          defaultMessage: nameRec,
        })
      : nameRec;
  return msg;
}

export {
  getInvisible,
  getValue,
  getReadOnly,
  getRequired,
  getLabel,
  getAling,
  recordToJs,
  getViewFields,
  recToTryton,
  getDefaults,
  validateForm,
  genStoreId,
  genHashCode,
  strTranslate,
};
